import React, { useState, useEffect, useCallback } from 'react'
import Badge from '@material-ui/core/Badge'
import Avatar from '@material-ui/core/Avatar'
import { isEmptyOrNil } from 'libs/empty'
import ErrorBoundary from './ErrorBoundary'
import { makeStyles, withStyles } from '@material-ui/styles'
import clsx from 'clsx'
import * as R from 'ramda'
import { resizeAvatar_250 } from 'commons/resizeImage'

const SmallAvatar = withStyles((theme) => ({
  root: {
    width: 16,
    height: 16,
    backgroundColor: '#fff',
  },
}))(Avatar)

const useStyles = makeStyles((theme) => ({
  black: {
    backgroundColor: '#071E3D',
  },
  navy: {
    backgroundColor: '#1F4287',
  },
  cyan: {
    backgroundColor: '#0E9CBC',
  },
  purple: {
    backgroundColor: '#7045AF',
  },
  magenta: {
    backgroundColor: '#E14594',
  },
  orange: {
    backgroundColor: '#E18745',
  },
}))

const bgColorSet = ['black', 'navy', 'cyan', 'purple', 'magenta', 'orange']

const AvatarWithFallback = ({
  fallbackName,
  fallbackSrc,
  className,
  src,
  Fallback,
  placeHolder,
  subId,
  badge = null,
  badgeClassName,
}) => {
  const avatarClasses = useStyles()
  const [isFailed, setIsFailed] = useState(false)
  useEffect(() => {
    setIsFailed(false)
  }, [src])

  const onError = useCallback(() => setIsFailed(true), [setIsFailed])

  const fallbackFirstChar =
    fallbackName !== undefined ? fallbackName.charAt(0) : ''
  const getFallbackComponent = () => {
    if (placeHolder) {
      return (
        <Badge
          className={clsx('inline', badgeClassName)}
          overlap="circle"
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          badgeContent={
            !R.isNil(badge) ? (
              <SmallAvatar alt="avatar badge" src={badge} />
            ) : null
          }
        >
          <Avatar
            className={clsx(className, avatarClasses[getBgClassName(subId)])}
          >
            {placeHolder}
          </Avatar>
        </Badge>
      )
    } else if (!isEmptyOrNil(fallbackSrc)) {
      return (
        <Badge
          className={clsx('inline', badgeClassName)}
          overlap="circle"
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          badgeContent={
            !R.isNil(badge) ? (
              <SmallAvatar alt="avatar badge" src={badge} />
            ) : null
          }
        >
          <Avatar src={fallbackSrc} className={className}>
            {fallbackFirstChar}
          </Avatar>
        </Badge>
      )
    } else if (!isEmptyOrNil(Fallback)) return Fallback
    else return null
  }

  const getAvatar = () => {
    if (isFailed || isEmptyOrNil(src)) return getFallbackComponent()
    else
      return (
        <Badge
          className={clsx('inline', badgeClassName)}
          overlap="circle"
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          badgeContent={
            !R.isNil(badge) ? (
              <SmallAvatar alt="avatar badge" src={badge} />
            ) : null
          }
        >
          <Avatar
            src={resizeAvatar_250(src)}
            className={className}
            onError={onError}
          >
            {getFallbackComponent()}
          </Avatar>
        </Badge>
      )
  }
  return (
    <ErrorBoundary fallback={getFallbackComponent()}>
      {getAvatar()}
    </ErrorBoundary>
  )
}

const getBgClassName = (subId) => {
  return parseInt(subId)
    ? bgColorSet[parseInt(subId) % bgColorSet.length]
    : bgColorSet[0]
}

export default React.memo(AvatarWithFallback)
